// @ts-nocheck
import React from 'react';
import IconButton from './IconButton';
import useTheme from './useTheme';

const SunIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const MoonIcon = ({ size = 15 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const ThemeToggle = (props) => {
  const { isDark, toggle } = useTheme();
  return (
    <IconButton
      icon={isDark ? SunIcon : MoonIcon}
      ariaLabel={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggle}
      {...props}
    />
  );
};

export default ThemeToggle;
